import type { LayoutBlock } from '@web-studio/shared-schemas';
import {
  sushiChefStory,
  sushiDynamicMenu,
  sushiFooter,
  sushiHeroEditorial,
  sushiMenuGrid,
  sushiNavigationHeader,
  sushiReservationForm,
} from '../blocks/sushiBar';

/** Restaurant / recommended — sushi seed with Growth Engine blocks. */
export const sushiBarRecommendedPage: LayoutBlock[] = [
  { ...sushiNavigationHeader, displayOrder: 0 },
  { ...sushiHeroEditorial, displayOrder: 1 },
  { ...sushiMenuGrid, displayOrder: 2 },
  { ...sushiDynamicMenu, displayOrder: 3 },
  { ...sushiChefStory, displayOrder: 4 },
  { ...sushiReservationForm, displayOrder: 5 },
  { ...sushiFooter, displayOrder: 6 },
];
